<header class="container-fluid container-sm p-lg-3 my-lg-4 {{stylesheet}}" *ngIf="topNavActive === true">
	<div class="row">
		<div class="col-12 my-3 my-lg-0 col-lg-5">
			<a href="{{baseUrl}}">
				<img [src]="''+cdnUrl+'images/artwork/'+systemKey+'/logo.svg'" class="img-fluid"
					alt="{{systemTitle}} ⋆ {{systemSlogan}}" />
			</a>
		</div>
		<div class="col-12 mb-3 my-lg-0 text-lg-right align-self-end col-lg-7">
			<nav class="main-nav">

				<section class="organisation-selecter-wrapper float-right"
					*ngIf="currentUser && currentUser['role'] == 'ADMIN'">
					<button type="button" (click)="toggleDropdown();"
						class="btn btn-light rounded btn-lg">{{currentOrganisation['name']}} <i
							class="pl-3 fas fa-caret-down"></i></button>
					<section class="organisation-selecter" *ngIf="showDropdown == true">
						<div class="organisation-selecter-search">
							<input (keyup)="searchOrganisation($event)" placeholder="Zoeken ... ">
						</div>
						<article class="organisation-selecter-list">
							<ng-container *ngFor="let organisation of organisations let i = index">
								<div *ngIf="organisation['hidden'] != true && organisation['active'] == 1"
									(click)="changeOrganisation(organisation.id)">{{organisation.name}}<span
										*ngIf="organisation.location"> ({{organisation.location}})</span> <small>
										{{organisation.city}}</small></div>
							</ng-container>
						</article>
					</section>
				</section>

				<div class="profileIcon">
					<ng-container *ngIf="!currentUser">
						<span *ngIf="currentUser == false"><a href="javascript:;" (click)="showRegisterModal()"
								class="btn btn-primary mx-md-3">Registreren</a></span>

						<span *ngIf="currentUser == false"><a href="javascript:;" (click)="showLogin()"
							class="btn btn-info mx-1 mx-md-3 loginButton">Inloggen</a></span>
					</ng-container>
					<div class="profileWrapper" *ngIf="currentUser">
						<span *ngIf="currentUser && currentUser['role'] != 'STUDENT'"><a href="{{portalUrl}}"
								class="btn btn-secondary mr-2">Docentenomgeving</a></span>

						<!-- <button class="btn btn-info" type="button">Profielpagina</button> -->
						<svg (click)="toggleMenu()" class="pointer" width="36" height="37" viewBox="0 0 36 37"
							fill="none" xmlns="http://www.w3.org/2000/svg">
							<g clip-path="url(#clip0_1456_11519)">
								<rect y="0.740265" width="36" height="36" rx="18" fill="white" />
								<g clip-path="url(#clip1_1456_11519)">
									<path
										d="M29.794 36.4134C29.794 30.2128 24.7918 25.186 18.6216 25.186C12.4514 25.186 7.44922 30.2128 7.44922 36.4134H29.794Z"
										fill="#51BF9D" stroke="#2D2B42" stroke-width="0.931034"
										stroke-miterlimit="10" />
									<path
										d="M18.6225 25.1494C23.2832 25.1494 27.0615 21.3526 27.0615 16.669C27.0615 11.9854 23.2832 8.18859 18.6225 8.18859C13.9618 8.18859 10.1836 11.9854 10.1836 16.669C10.1836 21.3526 13.9618 25.1494 18.6225 25.1494Z"
										fill="#FDD5A4" stroke="#2D2B42" stroke-width="0.931034"
										stroke-miterlimit="10" />
								</g>
							</g>
							<rect x="0.5" y="1.24026" width="35" height="35" rx="17.5" stroke="#2D2B42" />
							<defs>
								<clipPath id="clip0_1456_11519">
									<rect y="0.740265" width="36" height="36" rx="18" fill="white" />
								</clipPath>
								<clipPath id="clip1_1456_11519">
									<rect width="26.069" height="34.7586" fill="white"
										transform="translate(4.96484 1.98159)" />
								</clipPath>
							</defs>
						</svg>
						<ul [class]="{'show': showProfileDropdown}" class="dropdown-menu" #options>
							<li>
								<a class="pointer-none dropdown-item d-flex align-center">
									<svg _ngcontent-dea-c134="" width="36" height="37" viewBox="0 0 36 37" fill="none"
										xmlns="http://www.w3.org/2000/svg" class="pointer">
										<g _ngcontent-dea-c134="" clip-path="url(#clip0_1456_11519)">
											<rect _ngcontent-dea-c134="" y="0.740265" width="36" height="36" rx="18"
												fill="white"></rect>
											<g _ngcontent-dea-c134="" clip-path="url(#clip1_1456_11519)">
												<path _ngcontent-dea-c134=""
													d="M29.794 36.4134C29.794 30.2128 24.7918 25.186 18.6216 25.186C12.4514 25.186 7.44922 30.2128 7.44922 36.4134H29.794Z"
													fill="#51BF9D" stroke="#2D2B42" stroke-width="0.931034"
													stroke-miterlimit="10"></path>
												<path _ngcontent-dea-c134=""
													d="M18.6225 25.1494C23.2832 25.1494 27.0615 21.3526 27.0615 16.669C27.0615 11.9854 23.2832 8.18859 18.6225 8.18859C13.9618 8.18859 10.1836 11.9854 10.1836 16.669C10.1836 21.3526 13.9618 25.1494 18.6225 25.1494Z"
													fill="#FDD5A4" stroke="#2D2B42" stroke-width="0.931034"
													stroke-miterlimit="10"></path>
											</g>
										</g>
										<rect _ngcontent-dea-c134="" x="0.5" y="1.24026" width="35" height="35"
											rx="17.5" stroke="#2D2B42"></rect>
										<defs _ngcontent-dea-c134="">
											<clipPath _ngcontent-dea-c134="" id="clip0_1456_11519">
												<rect _ngcontent-dea-c134="" y="0.740265" width="36" height="36" rx="18"
													fill="white"></rect>
											</clipPath>
											<clipPath _ngcontent-dea-c134="" id="clip1_1456_11519">
												<rect _ngcontent-dea-c134="" width="26.069" height="34.7586"
													fill="white" transform="translate(4.96484 1.98159)"></rect>
											</clipPath>
										</defs>
									</svg>
									<div>
										<b>{{currentUser.email}}</b>
										<p>{{currentUser.organisationName}}</p>
									</div>
								</a>
							</li>
							<li>
								<hr class="dropdown-divider">
							</li>
							<ng-container *ngIf="currentUser['role'] != 'STUDENT'">
								<li><a href="{{portalUrl}}wishlist" target="_blank"
										class="dropdown-item">Verlanglijstje</a></li>
								<li><a href="{{portalUrl}}licenses" target="_blank" class="dropdown-item">Licenties</a>
								</li>
								<li><a href="https://uitgeverijneo.nl/bestelformulier" target="_blank"
										class="dropdown-item">Bestelformulier</a></li>
								<li>
									<hr class="dropdown-divider">
								</li>
							</ng-container>
							<li (click)="logout()"><a class="dropdown-item">Uitloggen</a></li>
						</ul>
					</div>
				</div>
			</nav>
		</div>
	</div>
</header>

<router-outlet></router-outlet>

<section class="toasts-container">
	<article class="toast show" *ngFor="let toast of toasts">
		<div *ngIf="toast['type'] == 'login'">
			<button type="button" (click)="removeToast(toast['id'])" class="toast-btn-close"><i
					class="fas fa-times"></i></button>
			<div class="toast-body toast-with-icon">
				<div class="toast-icon"><i class="fas fa-check-circle"></i></div>
				<div class="toast-content">We kunnen je inloggen met je schoolaccount. <span (click)="doEntreeLogin()"
						class="entree-link">Klik hier om je automatisch aan te melden.</span></div>
			</div>
		</div>
		<div *ngIf="toast['type'] == 'check'">
			<button type="button" (click)="removeActivityToast(toast['id'])" class="toast-btn-close"><i
					class="fas fa-times"></i></button>
			<div class="toast-body toast-with-icon">
				<div class="toast-icon"><i class="fas fa-check-circle"></i></div>
				<div class="toast-content">
					Hey! Je kunt gaan nakijken:
					<span style="color: rgb(105, 105, 255); cursor: pointer;"
						(click)="openToast('/les/' + currentCheckRequest['chapterLessonId'])">{{currentCheckRequest['lessonTitle']}}</span>
				</div>
			</div>
		</div>
		<div *ngIf="toast['type'] == 'text'">
			<button type="button" (click)="removeToast(toast['id'])" class="toast-btn-close"><i
					class="fas fa-times"></i></button>
			<div class="toast-body toast-with-icon">
				<div class="toast-icon"><i class="fas fa-check-circle"></i></div>
				<div class="toast-content">{{ toast['content'] }}</div>
			</div>
		</div>
	</article>
</section>

<span (click)="toTop()" class="back-to-top rounded-circle" id="toTop" title="Terug naar boven"
	*ngIf="showRocket == true"><i class="fas fa-rocket fa-sm"></i></span>

<footer class="{{stylesheet}}">
	<img *ngIf="stylesheet == 'sections' && topNavActive === false" id="bxLogo"
		[src]="''+cdnUrl+'images/artwork/'+systemKey+'/logo_block_white.svg'" alt="{{systemTitle}} ⋆ {{systemSlogan}}">
	<img *ngIf="stylesheet == 'sections' && topNavActive === true" id="bxLogo"
		[src]="''+cdnUrl+'images/artwork/'+systemKey+'/logo_block_yellow.svg'" alt="{{systemTitle}} ⋆ {{systemSlogan}}">
	<div class="container p-3 clearfix">
		<p>&copy; {{getCurrentYear()}} Uitgeverij NEO. Alle rechten voorbehouden. Niets uit deze uitgave mag worden
			verveelvoudigd, opgeslagen in een geautomatiseerd gegevensbestand, of openbaar gemaakt, in enige vorm of op
			enige wijze, hetzij elektronisch, mechanisch, door fotokopieën, opnamen, of enige andere manier, zonder
			voorafgaande schriftelijke toestemming van de uitgever.</p>
		<p class="float-lg-left"><span
				*ngIf="defaultAuthorName != authorName">Auteur&nbsp;<strong>{{authorName}}</strong> &middot; </span>
			Vormgeving <a href="https://roef.studio/" target="_blank" rel="nofollow"><strong>ROEF</strong></a> &middot;
			Techniek <a href="https://adaptivity.nl/" target="_blank" rel="nofollow"><strong>Adaptivity</strong></a></p>
		<p class="float-lg-right"> <a href="https://uitgeverijneo.nl/files/privacybeleid.pdf">Privacybeleid</a> &middot; <a
				href="{{baseUrl}}info/colofon/">Colofon</a> &middot; <a href="{{salesWebsite}}">Over {{systemTitle}}</a>
		</p>
	</div>
</footer>
<ngx-ui-loader></ngx-ui-loader>